
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 17.909h17V5.974h-5.652V7.16h4.087v9.562H1.565V7.16h4.087V5.974H0z"}}),_c('path',{attrs:{"d":"M8.931 11.447V2.073l2.64 2.263.772-.902L8.338 0 4.332 3.434l.773.902 2.64-2.263v9.374z"}})])
          )
        }
      }
    